import React, { useEffect, useRef, useState } from "react";
import { CheckIcon, CloseIcon } from "../../../constants/Icons";

const UpdateQty = ({ data, ItemIndex, updateQuantity, onClose }) => {
  const [inputValue, setInputValue] = useState(data.purchaseQuantity || 1);
  const [errorMessage, setErrorMessage] = useState("");
  const inputRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    setInputValue(data.purchaseQuantity || 1);
    setErrorMessage("");
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [data.purchaseQuantity]);

  const handleUpdate = () => {
    const parsedQuantity = parseInt(inputValue, 10);
    if (!isNaN(parsedQuantity) && parsedQuantity > 0) {
      setErrorMessage("");
      updateQuantity(data, ItemIndex, parsedQuantity); // ✅ send final value directly
    } else {
      setErrorMessage("Enter a valid quantity greater than 0.");
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    setInputValue(value ? parseInt(value, 10) : "");
    setErrorMessage("");
  };

  const handleIncrease = () => {
    setInputValue((prev) => prev + 1);
  };

  const handlePaymodeKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleUpdate(e);
    }
  };

  const handleDecrease = () => {
    setInputValue((prev) => Math.max(prev - 1, 1));
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  return (
    <div>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        id="CustomerModal"
        tabIndex="0"
        aria-modal="true"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Update Quantity</h6>
              <button
                type="button"
                onClick={onClose}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <h6 className="text-center">{data.title}</h6>
              {data.isStock && (
                <h6 className="text-center">
                  <small>Stock Left - </small>
                  &nbsp;
                  <span className="badge bg-label-space">{data.stockLeft}</span>
                </h6>
              )}
              <div className="d-flex justify-content-center align-items-center mt-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleDecrease}
                >
                  −
                </button>
                <input
                  type="text"
                  value={inputValue}
                  ref={inputRef}
                  onFocus={(e) => e.target.select()}
                  onChange={handleInputChange}
                  onKeyDown={(e) => handlePaymodeKeyDown(e)}
                  className="form-control text-center mx-2"
                  style={{ width: "80px" }}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={handleIncrease}
                >
                  +
                </button>
              </div>
              {errorMessage && (
                <div className="text-danger text-center mt-2">
                  {errorMessage}
                </div>
              )}
            </div>
            <div className="modal-footer d-block">
              <button
                onClick={onClose}
                type="button"
                data-bs-dismiss="modal"
                className="btn btn-outline-secondary text-left"
              >
                <CloseIcon iClass={"fs-15"}/> Cancel
              </button>
              <button
                ref={buttonRef}
                onClick={handleUpdate}
                type="button"
                className="btn btn-primary text-right"
              >
                <CheckIcon/>
                <CheckIcon/> Update
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateQty;
